import React, {useState} from 'react';
import {Box, Typography, Grid, Card, CardContent, TextField, Button} from "@mui/material";
import partenaire from '../images/partenaire.jpg'
import Grid2 from "@mui/material/Unstable_Grid2";
import emailjs from "emailjs-com";
import {motion} from "framer-motion";

const Partenariat = () => {

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        compagny: '',
        phoneNumber:'',
        message: '',
    });

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        emailjs.send(
            'service_bd6pp67',   // Remplacez par le SERVICE_ID EmailJS
            'template_2w3sunu',  // Remplacez par le TEMPLATE_ID EmailJS
            formData,
            'e-ybTJj1CPzfHM6VG'       // Remplacez par le USER_ID EmailJS
        )
            .then((result) => {
                console.log('Email envoyé:', result.text);
                alert('Votre message a été envoyé avec succès !');
            })
            .catch((error) => {
                console.log('Erreur lors de l\'envoi de l\'e-mail:', error.text);
                alert('Erreur lors de l\'envoi du message. Veuillez réessayer.');
            });
    };

    const fadeInUp = {
        initial: { opacity: 0, y: 30 },
        animate: { opacity: 1, y: 0 },
        transition: { duration: 0.8, ease: "easeOut" },
    };

    return (
        <Box
            sx={{
                backgroundColor: '#f0f4fa',
                padding: '50px 0',
                display: 'flex',
                alignItems: 'center', // Centre les éléments verticalement
                justifyContent: 'center', // Centre les éléments horizontalement
                //minHeight: '100vh', // Occupe toute la hauteur de la fenêtre
            }}
        >
            <Box
                maxWidth="lg"
                sx={{
                    margin: '0 auto',
                    padding: { xs: '20px', md: '50px' },
                    display: 'flex',
                    alignItems: 'center', // Centre les éléments verticalement
                    justifyContent: 'center', // Centre les éléments horizontalement
                    flexDirection: { xs: 'column', md: 'row' },
                    gap: { xs: 4, md: 8 },
                }}
            >
                <Grid2 container spacing={7} alignItems="center" justifyContent="center">
                    {/* Texte à gauche */}
                    <Grid2 xs={12} md={7} component={motion.div} {...fadeInUp}>
                        <Typography variant="h3" gutterBottom sx={{ fontWeight: 'bold', color: '#3f72b5', fontFamily: 'unset', textAlign: 'center' }}>
                            Rejoignez notre réseau de partenaires !
                        </Typography>
                        <Typography variant="body1" sx={{ color: '#333', lineHeight: 1.6, fontFamily: 'unset', textAlign: { xs: 'center', md: 'left' } }}>
                            Chez CP, nous croyons au pouvoir de la collaboration pour proposer des solutions toujours plus performantes et innovantes.
                            Nous sommes constamment à la recherche de partenaires motivés et qualifiés pour élargir notre réseau et offrir le meilleur à nos clients.
                            <br /><br />
                            En rejoignant notre équipe en tant que <strong>partenaire</strong> ou <strong>sous-traitant</strong>, vous accédez à des opportunités de collaboration sur divers projets dans les domaines de l’électricité, de la domotique, des énergies renouvelables, et bien plus. Ensemble, nous créons un impact positif pour un avenir plus sûr, efficace et respectueux de l'environnement.
                            <br /><br />
                            <span style={{ fontWeight: 'bold', fontSize: '1.3em' }}>Pourquoi nous rejoindre ?</span>
                            <ul style={{ paddingLeft: 0, listStyleType: 'none', }}>
                                <li><strong>Opportunités variées</strong> : Collaborez avec une équipe d'experts sur des projets innovants et stimulants.</li>
                                <li><strong>Croissance commune</strong> : Développez vos compétences et enrichissez votre expérience grâce à notre soutien et notre savoir-faire.</li>
                                <li><strong>Impact durable</strong> : Contribuez activement à la transition énergétique et aux projets technologiques écoresponsables.</li>
                            </ul>
                            <br />
                            <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#3f72b5', fontFamily: 'unset', textAlign: 'center' }}>
                                Intéressé(e) ? Remplissez le formulaire ci-dessous pour soumettre votre demande de partenariat ou pour rejoindre notre réseau de sous-traitants.
                            </Typography>
                        </Typography>
                    </Grid2>

                    {/* Image à droite */}
                    <Grid2  xs={12} md={5} display="flex" justifyContent="center" component={motion.div} {...fadeInUp} transition={{ delay: 0.5 }}>
                        <Box
                            component="img"
                            src={partenaire} // Remplacez par l'URL de l'image
                            alt="Partenaire"
                            sx={{
                                width: '100%',
                                height: '100%',
                                maxWidth: '400px', // Limite la taille de l'image
                                borderRadius: 2,
                                boxShadow: '0px 4px 10px rgba(0,0,0,0.2)',
                                objectFit: 'cover',
                            }}
                        />
                    </Grid2>

                    <Grid2 xs={12} md={12} paddingTop={5} component={motion.div} {...fadeInUp} transition={{ delay: 0.4 }}>
                        <Card sx={{ boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.1)', borderRadius: 5 }}>
                            <CardContent>
                                <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 2, fontFamily: 'unset' }}>
                                    Entrer en contact
                                </Typography>
                                <Typography variant="body1" sx={{ mb: 2, fontFamily: 'unset' }}>
                                    Compléter le formulaire :
                                </Typography>
                                <form onSubmit={handleSubmit}>
                                    <Grid2 container spacing={2}>
                                        <Grid2 xs={12} sm={6}>
                                            <TextField fullWidth
                                                       label="Votre nom"
                                                       name="name"
                                                       variant="outlined"
                                                       value={formData.name}
                                                       onChange={handleChange}
                                                       required
                                                       InputProps={{
                                                           sx: {
                                                               borderRadius: 5, // arrondir les coins
                                                               fontFamily: 'inherit'
                                                           },
                                                       }}

                                            />
                                        </Grid2>
                                        <Grid2 xs={12} sm={6}>
                                            <TextField fullWidth
                                                       label=" Votre societé"
                                                       name="compagny"
                                                       onChange={handleChange}
                                                       variant="outlined"
                                                       value={formData.compagny}
                                                       InputProps={{
                                                           sx: {
                                                               borderRadius: 5, // arrondir les coins
                                                               fontFamily: 'inherit'
                                                           },
                                                       }}
                                            />
                                        </Grid2>
                                        <Grid2 xs={12}>
                                            <TextField fullWidth label="Votre email"
                                                       variant="outlined"
                                                       name="email"
                                                       onChange={handleChange}
                                                       type="email"
                                                       value={formData.email}
                                                       required
                                                       InputProps={{
                                                           sx: {
                                                               borderRadius: 5, // arrondir les coins
                                                               fontFamily: 'inherit'
                                                           },
                                                       }}
                                            />
                                        </Grid2>
                                        <Grid2 xs={12}>
                                            <TextField fullWidth
                                                       label="Numéro de téléphone"
                                                       variant="outlined"
                                                       name="phoneNumber"
                                                       onChange={handleChange}
                                                       type="tel"
                                                       value={formData.phoneNumber}
                                                       required
                                                       InputProps={{
                                                           sx: {
                                                               borderRadius: 5, // arrondir les coins
                                                               fontFamily: 'inherit'
                                                           },
                                                       }}
                                            />

                                        </Grid2>
                                        <Grid2 xs={12}>
                                            <TextField
                                                fullWidth
                                                label="Comment pouvons-nous vous aider ?"
                                                variant="outlined"
                                                name="message"
                                                value={formData.message}
                                                onChange={handleChange}
                                                multiline
                                                rows={4}
                                                InputProps={{
                                                    sx: {
                                                        borderRadius: 5, // arrondir les coins
                                                        fontFamily: 'inherit'
                                                    },
                                                }}
                                            />
                                        </Grid2>
                                        <Grid2 xs={12}>
                                            <Button type={"submit"} fullWidth variant="contained" sx={{ backgroundColor: '#3f72b5', color: '#fff', borderRadius: 5, fontFamily: 'unset' }}>
                                                Envoyer
                                            </Button>
                                        </Grid2>
                                    </Grid2>
                                </form>
                                {/*<Typography variant="body2" sx={{ mt: 2 }}>*/}
                                {/*    By contacting us, you agree to our{' '}*/}
                                {/*    <span style={{ color: '#2979ff', cursor: 'pointer' }}>Terms of service</span> and{' '}*/}
                                {/*    <span style={{ color: '#2979ff', cursor: 'pointer' }}>Privacy Policy</span>.*/}
                                {/*</Typography>*/}
                            </CardContent>
                        </Card>
                    </Grid2>
                </Grid2>
            </Box>
        </Box>
    );
};

export default Partenariat;
